<style lang="scss" scoped>
.entwicklungsplan-outer {
  p {
    background: $c-white;
    padding: 10px;
    margin-bottom: 0;
  }
}

.zusammenarbeit:nth-child(odd) {
  background-color: $c-white;
}
</style>

<template>
  <div class="row" v-if="zusammenarbeiten && zusammenarbeiten.length > 0">
    <div class="col-3"><b>Mitarbeiter:in</b></div>
    <div class="col-3"><b>Projekt</b></div>
    <div class="col-6"><b>Notizen</b></div>
  </div>
  <div class="row mt-2 justify-items-start zusammenarbeit" :key="item.userid + item.text" v-for="item of zusammenarbeiten">
    <div class="col-3">
      {{ item.userid }}
    </div>
    <div class="col-3">
      {{ item.text }}
    </div>
    <div class="col-6">
      {{ item.note }}
    </div>
  </div>
  <div class="row entwicklungsplan-outer" v-if="!zusammenarbeiten || zusammenarbeiten.length == 0">
    <div class="col-12"><p>- Es wurden noch keine Projektzusammenarbeiten hinterlegt -</p></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

type Zusammenarbeit = {
  userid: number;
  text: string;
  note: string;
};

export default defineComponent({
  props: {
    user: { type: Number, required: true },
  },
  setup(props) {
    const zusammenarbeiten = ref<Array<Zusammenarbeit>>([]);
    const store = useStore();

    onMounted(() => {
      store.dispatch('fetchZusammenarbeit', props.user).then((res) => {
        zusammenarbeiten.value = res;
      });
    });

    return {
      zusammenarbeiten,
    };
  },
});
</script>
